/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderActiveCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderActiveCtrl', ["dialog", "$scope", "StockPurchaseOrders", "$state", "$timeout", "title", "logger", "features", function(dialog, $scope, StockPurchaseOrders, $state, $timeout, title, logger, features) {
  title.set('Outstanding Orders');

  var pendingPollTimeout = null;
  var previousPageVisibilityState = 'visible';

  /**
   * Poll handling for purchase orders.
   */
  function pollOrderStatus(immediate) {

    var poll = StockPurchaseOrders.getPurchaseOrderPollDelay($scope.orders, immediate);

    if (!poll.required) {
      return;
    }

    logger.info('scheduling purchase orders api call with delay of %s', poll.delay);
    pendingPollTimeout = $timeout(function() {
      StockPurchaseOrders.getOutstanding().$promise
        .then(function(orders) {
          $scope.orders = orders;
        });
      pollOrderStatus();
    }, poll.delay);

  }

  /**
   * Helper to react to any window visibility changes and refresh purchase
   * orders if appropriate.
   */
  function handleVisibilityChange() {
    if (document.visibilityState === 'visible' && previousPageVisibilityState !== 'visible') {
      // When the page becomes visible after being in some other state we
      // trigger a refresh of the purchase order data immediately. This is done
      // to help users that leave a tab on the purchase orders page open in the
      // background / overnight and then come back to that tab later on - we
      // update the data so it behaves like it used to (polling every 10s forever).
      logger.info('triggering immediate data refresh due to page becoming visible again');
      $timeout.cancel(pendingPollTimeout);
      pollOrderStatus(true);
    }
    previousPageVisibilityState = document.visibilityState;
  }

  $scope.loading = StockPurchaseOrders.getOutstanding().$promise;
  $scope.loading.then(function(orders) {
    $scope.orders = orders;

    pollOrderStatus();
    document.addEventListener('visibilitychange', handleVisibilityChange);
  });

  $scope.commLog = function(order) {
    $scope.logs = StockPurchaseOrders.getCommLog(order.id);

    dialog.open({
      templateUrl: 'modules/stock/purchaseorder/commlog.tpl.html',
      scope: $scope,
      size: 'lg'
    });
  };

  $scope.$on('$destroy', function() {
    $timeout.cancel(pendingPollTimeout);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });

  $scope.validate = function(id) {
    $state.go('.Validate', {id: id}, {location: 'replace'});
  };

  $scope.AIPoweredStockOrderingEnabled = false;
  features.isEnabled('alpha')
    .then(function(isAlpha) {
      $scope.AIPoweredStockOrderingEnabled = isAlpha;
    });  
}]);
